<template>
    <div class="pages newMemberGroup">
        <div class="title mb-30">
            <p >
                <img src="../../assets/images/newIcon/addlabel2_icon.png" alt="">
                <span>{{id ? '修改标签' : '新建标签'}} </span>
            </p>
            <p>

            </p>
        </div>
        <div class="content">
            <div class="tabw mb-30" >
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="标签名称：">
                        <el-input v-model="form.name" placeholder="标题仅作为企业内部管理使用"></el-input>
                    </el-form-item>
                    <el-form-item label="标签类型：">
                        <el-radio-group v-model="form.type">
                            <el-radio label="1">运营标签</el-radio>
                            <el-radio label="2">规则标签</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="选择标签组：">
                        <el-select v-model="form.region" placeholder="请选择标签组">
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            
            <div class="tabt" v-if="form.type==2" >
                <!-- <labelPopulation @dostep="createds" :type='form.type' v-if="form.type==3 || form.type==1" ref="labelPopulation"></labelPopulation> -->
                <featuresPopulation :type='form.type' @dostep="createds" ref="featuresPopulation"></featuresPopulation>
            </div>
            <span class="footer" v-if="form.type==1">
                <el-button class="quxiao" @click="goType(1)">取消</el-button>
                <el-button type="primary" @click="goType(2)">保存</el-button>
            </span>
        </div>
    </div>
</template>

<script>
import labelPopulation from './components/labelPopulation.vue'
import featuresPopulation from './components/featuresPopulation.vue'
export default {
    data() {
        return {
            id:"",
            types:1,
            form: {
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: "2",
            resource: '',
            desc: ''
            }
        }
    },
    components:{
        labelPopulation,
        featuresPopulation
    },
    created(){
        this.id=this.$route.query.id;
    },
    methods: {
        createds(obj){
            // console.log(val,111111)
            // if(val.type==1){
            //     this.types=--this.types;
            // }
            if(obj.type==2){
                this.$router.push({ name: "labelManagement" });
                this.$message({
                message: "恭喜你，保存成功",
                type: "success",
                });
            }else{
                 this.$router.push({ name: "labelManagement" });
            }
        },
        goType(type){
            if(type==2){
                this.$router.push({ name: "labelManagement" });
                this.$message({
                message: "恭喜你，保存成功",
                type: "success",
                });
            }else{
                 this.$router.push({ name: "labelManagement" });
            }
        },
        handleClose(){
            this.$router.go(-1)
        },
    },
}
</script>
<style lang="less" scoped>
    .footer {
        display: block;
        background: #fff;
        padding: 15px 30px;
        border-top: 1px solid #ededed;
        .el-button {
            border-radius: 30px;
        }
    }
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .content{
        .tabw{
            // width:60%;
            padding:30px;
            border-radius: 6px;
            background: #fff;
            .el-form{
                width:40%;
            }
            .el-select{
                width:100%;
            }
            /deep/.el-textarea .el-textarea__inner{
                // width:100%;
                border:0;
                background:#F6F6F6;
            }
            /deep/.el-input .el-input__inner{
                border-radius: 30px;
                background: #F6F6F6;
                border: 0px;
            }
            .min_ipt{
                margin:0 10px;
                width:100px;
            }
            .liex{
                 margin-top:15px;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
            .el-form-item{
                margin-bottom:15px;
            }
        }
        .footer{
            display: block;
            background: #fff;
            padding:15px 30px;
            border-top:1px solid #ededed;
            .el-button{
                border-radius: 30px;
            }
        }
    }
</style>